import React from "react";
import { Box, Tooltip, Typography } from "@mui/material";

const formatTemplateRange = (range) => {
    if (typeof range === 'string') return range;
    if (!range || typeof range !== 'object') return '';
    if (typeof range.range === 'string') return range.range;
    if (typeof range.note === 'string') return range.note;
    const hasMin = range.min !== undefined && range.min !== null && range.min !== '';
    const hasMax = range.max !== undefined && range.max !== null && range.max !== '';
    if (hasMin && hasMax) return `${range.min} – ${range.max}`;
    if (hasMin) return `≥ ${range.min}`;
    if (hasMax) return `≤ ${range.max}`;
    return '';
};

// Shows the range in brackets right after the field name it wraps.
// Range printed on the uploaded report wins; otherwise the catalog default, in italics so it isn't mistaken for the lab's.
const ReferenceRange = ({ printed, template, children }) => {
    const printedText = typeof printed === 'string' ? printed.trim() : '';
    const text = printedText || formatTemplateRange(template);
    if (!text) return children ?? null;
    const isDefault = !printedText;
    return (
        <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.5, minWidth: 0, maxWidth: '100%' }}>
            {children}
            <Tooltip title={isDefault ? `Default range from the test template: ${text}` : `Reference range on the report: ${text}`}>
                <Typography component="span" sx={{ fontSize: '10px', color: 'text.secondary', fontStyle: isDefault ? 'italic' : 'normal', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', flexShrink: 0, maxWidth: '60%' }}>
                    ({text})
                </Typography>
            </Tooltip>
        </Box>
    );
};

export default ReferenceRange;
